import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo, createContext } from 'react';
import { ThemeContext } from 'styled-components';
import { tokenMapping } from './tokenMapping';
import { getActiveMode } from './utils';
function mergeMode(mode, outerMode) {
  if (typeof mode === 'string') {
    return mode;
  }
  if (typeof outerMode === 'string') {
    return {
      rest: outerMode,
      ...mode
    };
  }
  return outerMode ? {
    ...outerMode,
    ...mode
  } : mode;
}
export const ModeContext = /*#__PURE__*/createContext(undefined);
export const ModeConsumer = ModeContext.Consumer;
export const ModeProvider = _ref => {
  let {
    mode,
    children
  } = _ref;
  const themeContext = useContext(ThemeContext);
  const brand = themeContext.id;
  const activeMode = getActiveMode(brand, mode);
  const outerMode = useContext(ModeContext);
  const modeContext = useMemo(() => mergeMode(mode, outerMode), [mode, outerMode]);
  return /*#__PURE__*/_jsx(ModeContext.Provider, {
    value: modeContext,
    children: /*#__PURE__*/_jsx("div", {
      "data-mesh-component": "MODE-PROVIDER",
      "data-mode": activeMode,
      children: children
    })
  });
};
export { getActiveMode, tokenMapping };